import React from 'react';

import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CertificationCard = ({ certification, onView, onDownload }) => {
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all duration-300">
      <div className="relative h-40 bg-gradient-to-br from-primary to-secondary p-6 flex items-center justify-center">
        <div className="text-center">
          <Icon name="Award" size={48} color="white" className="mx-auto mb-2" />
          <h3 className="text-white font-semibold text-lg">{certification?.title}</h3>
        </div>
        {certification?.verified && (
          <div className="absolute top-4 right-4 bg-white rounded-full p-2">
            <Icon name="CheckCircle" size={20} className="text-green-600" />
          </div>
        )}
      </div>
      <div className="p-6">
        <div className="mb-4">
          <div className="flex items-center justify-between text-sm mb-2">
            <span className="text-muted-foreground">Issued By</span>
            <span className="font-medium text-foreground">{certification?.issuer}</span>
          </div>
          <div className="flex items-center justify-between text-sm mb-2">
            <span className="text-muted-foreground">Issue Date</span>
            <span className="font-medium text-foreground">{certification?.issueDate}</span>
          </div>
          {certification?.expiryDate && (
            <div className="flex items-center justify-between text-sm mb-2">
              <span className="text-muted-foreground">Expires</span>
              <span className="font-medium text-foreground">{certification?.expiryDate}</span>
            </div>
          )}
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Credential ID</span>
            <span className="font-mono text-xs text-foreground">{certification?.credentialId}</span>
          </div>
        </div>

        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onView(certification)}
            className="flex-1"
            iconName="Eye"
            iconPosition="left"
          >
            View
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={() => onDownload(certification)}
            className="flex-1"
            iconName="Download"
            iconPosition="left"
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CertificationCard;